if (window.innerWidth >= 992) {
  const lists = document.querySelectorAll('.event-list') || [];

  lists.forEach(list => {

    const items = list.querySelectorAll('.event-list-item') || [];
    const isActive = [...list.parentElement.classList].indexOf('active') >= 0;

    list.parentElement.classList.add('active', 'show');

    items.forEach((item, index) => {
      if (!items[index+1]) {
        return;
      }

      const nextItem = items[index+1];
      const classes = ['col-lg-3', 'col-lg-4'];
      const hasClass = (element) => classes.indexOf(element) >= 0;

      if (![...item.classList].some(hasClass)) {
        return;
      }

      if (![...nextItem.classList].some(hasClass)) {
        return;
      }

      item.style.setProperty('margin-bottom', `-${item.offsetHeight / 2}px`, 'important');
    });

    if (!isActive) {
      list.parentElement.classList.remove('active', 'show');
    }
  });
}

export default {};
